export default __webpack_public_path__ + "static/media/CloseIcon.1166e22a.svg";